export default __webpack_public_path__ + "images/HW.433564d.png";